// extracted by mini-css-extract-plugin
export default {"box":"CategoryCard_box__R7Vmd","imgBox":"CategoryCard_imgBox__i7UyZ"};